import dayjs from 'dayjs'

/**
 * Formats a given date or date string using the specified format string.
 *
 * @param date The input date as a Date object, number or a string representation of a date.
 * @param format The desired format string for formatting the date (e.g., 'YYYY.MM.DD HH:mm').
 * @returns The formatted date string based on the provided format.
 *          Returns an empty string if either the date or format is missing or invalid.
 */
export function useDateFormat(date: Date | string | number, format: string): string {
    if (!date || !format) {
        return ''
    }

    return dayjs(date).format(format)
}

/**
 * Formats a given date or date string using the specified format string.
 *
 * @param timestamp The input timestamp as a number representation of a date.
 * @param format The desired format string for formatting the date (e.g., 'MMM DD, YYYY [at] HH:mm A').
 * @returns The formatted date string based on the provided format.
 *          Returns an empty string if either the date or format is missing or invalid.
 */
export function useTimestampDateFormat(timestamp: number, format: string): string {
    if (!timestamp || !format) {
        return ''
    }

    return dayjs(timestamp * 1000).format(format)
}
